module.exports = __webpack_public_path__ + "static/bg (13)-72c804b293fc12b7a307ccbbb966a9e7.jpg";